import { Card, Dialog, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CardWrapper = styled(Grid)({
  padding: "5px",
});

export const StyledCard = styled(Card)(({ theme }) => ({
  display: "flex",
  backgroundColor: theme.palette.background.default,
  borderRadius: "0px",
  gap: "10px",
  height: "150px",
}));

export const BlockSelect = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "20px 0px 20px 10px",
});

export const UndefinedFieldText = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.light,
  fontStyle: "italic",
}));

export const BlockDocumentAndDate = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  // gap: "10px",
  justifyContent: "center",
  alignItems: "center",
  padding: "10px 0px 10px 10px",
  "&>.MuiTypography-root": {
    textAlign: "center",
  },
});

export const DateContainer = styled(Grid)(({ theme }) => ({
  color: theme.palette.secondary.light,
  display: "flex",
  "& >.MuiTypography-root": {
    fontSize: "28px",
  },
  "& .MuiGrid-root": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    "& .MuiTypography-root": {
      lineHeight: "13px",
    },
  },
}));

export const BlockProcessTypeAndPostVia = styled(Grid)({
  padding: "10px 0px 10px 0px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});

export const BlockTo = styled(Grid)({
  display: "flex",
  alignItems: "center",
  padding: "10px 0px 10px 0px",
  gap: "5px",
});

export const AddresseeNicknameContainer = styled(Grid)({
  // display : "flex",
  // gap : "5px ",
});

export const AddresseNickname = styled(Typography)(({ theme }) => ({
  maxWidth: "20ch",
  overflow: "hidden",
  textOverflow: "ellipsis",
  color: theme.palette.primary.main,
}));

export const BlockDocuments = styled(Grid)(({ theme }) => ({
  padding: "10px 0px 10px 0px",
  display: "flex",
  gap: "15px",
  "&>.MuiGrid-root": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: theme.palette.secondary.light,
    "& .MuiTypography-root": {
      display: "contents",
    },
  },
}));

export const BlockStatuses = styled(Grid)({
  display: "flex",
  gap: "10px",
});

export const StatusContainer = styled(Grid)({
  minWidth: "140px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "10px",
  textAlign: "center",
  "& .MuiTypography-root:first-of-type": {
    fontSize: "17px",
  },
});

export const BlockEdit = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "10px 10px 10px 0px",
});

export const DocumentViewerContainer = styled(Dialog)({
  overflow: "hidden",
  "& .MuiPaper-root": {
    maxWidth: "fit-content",
  },
});
